module.exports = __webpack_public_path__ + "img/icon_item0.5554e242.png";